// extracted by mini-css-extract-plugin
export default {"ctaWrapper":"XY-z","subtitle":"YY-z","wrapper":"ZY-z","leftArrow":"_Y-z","rightArrow":"aZ-z"};